import { ConnectorType } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllConnectorTypes = () => getAllEnumOptions(ConnectorType)

export const getConnectorTypeLabel = (key?: ConnectorType) => {
  if (key === null || typeof key === 'undefined') return ''

  return ConnectorType[key]
}
